import apiAxios from '@/services/axiosConfig';
import type { UpdateSettingsRequest } from '@/types/api';

async function updateSettings(data: UpdateSettingsRequest): Promise<void> {
  await apiAxios.patch('/api/v1/mt/settings', data);
}

export default updateSettings;
